<template>
	<div class="page-base"></div>
</template>

<script lang="ts">
	import ChalkySticks from '@chalkysticks/sdk';
	import ViewBase from '@/Core/View.vue';
	import { Component } from 'vue-property-decorator';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package Core
	 * @project ChalkySticks
	 */
	@Component
	export default class PageBase extends ViewBase {
		/**
		 * @return ChalkySticks.Core.Input.Pointer
		 */
		public get pointer(): ChalkySticks.Core.Input.Pointer {
			return ChalkySticks.Core.Input.Pointer.instance;
		}

		/**
		 * @return ChalkySticks.Core.Input.Shortcut
		 */
		public get shortcut(): ChalkySticks.Core.Input.Shortcut {
			return new ChalkySticks.Core.Input.Shortcut();
		}
	}
</script>
